import React from 'react'
import Logotip from '../../ui/Logotip/Logotip'
import "./header.css"
import NavbarMenu from '../../ui/NavbarMenu/NavbarMenu'
import { PlanetName } from '../../App'

export interface HeaderProps {
  onSetPlanet: (planet: PlanetName) => void; 
}

const Header = ({onSetPlanet}:HeaderProps) => {

  return (
    <header id='header'>
      <Logotip/>
      <NavbarMenu onSetPlanet={onSetPlanet}/>
    </header>
  )
}

export default Header
